import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";
import {ORGANIZATION_SERVER} from "@/api";

const userGroupRole = new RestResource({server: ORGANIZATION_SERVER, resource: 'userGroupRole'});

userGroupRole.batchAdd = (userGroupRoles) => {
    let userGroupId = userGroupRoles[0].userGroupId;
    let roleIds = userGroupRoles.map(e => e.roleId);
    let url = `${ORGANIZATION_SERVER}/userGroupRole/bind/userGroupId/${userGroupId}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, roleIds).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default userGroupRole;